import * as React from 'react';
import styled from 'styled-components';

import { BREAK_POINTS } from '../consts/style';
import { GoodEnergySvg } from '../images/svg/GoodEnergySvg';

const GoodEnergyContainer = styled.div`
  width: 151px;
  @media (min-width: ${BREAK_POINTS.MAX.LG}) {
    width: 185px;
  }
`;

const GoodEnergyContainerSmall = styled.div`
  width: 100px;
  height: 48px;
  @media (min-width: ${BREAK_POINTS.MAX.XS}) {
    width: 118px;
    height: 56px;
  }
`;

export const GoodEnergy = ({ className }: { className?: string }) => (
  <GoodEnergyContainer className={className}>
    <GoodEnergySvg />
  </GoodEnergyContainer>
);

export const GoodEnergySmall = () => (
  <GoodEnergyContainerSmall>
    <GoodEnergySvg />
  </GoodEnergyContainerSmall>
);
